import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const articleAudio = {
  createArticleAudio: lazyModuleMethod(
    () => import('./createArticleAudio'),
    'default'
  ),
  editArticleAudio: lazyModuleMethod(
    () => import('./editArticleAudio'),
    'default'
  ),
  fetchArticleAudio: lazyModuleMethod(
    () => import('./fetchArticleAudio'),
    'default'
  ),
}
